import { render, staticRenderFns } from "./maintenance-bar.vue?vue&type=template&id=246a2e90&scoped=true&"
import script from "./maintenance-bar.vue?vue&type=script&lang=js&"
export * from "./maintenance-bar.vue?vue&type=script&lang=js&"
import style0 from "./maintenance-bar.vue?vue&type=style&index=0&id=246a2e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a2e90",
  null
  
)

export default component.exports